export default "__VITE_ASSET__BzbF3y3T__"